<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Product Stock
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="2">
              <v-autocomplete
                ref="gift Category"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                readonly
                disabled
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Product Stock
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreProductStockCreatePage",
  data() {
    return {
      form: {
        store_product_id: null,
        store_id: null,
        name: "",
        date: "",
        quantity: "",
      },
      store_product: {},
      productItems: [],
      storeItems: [],
      isLoading: false,
      menu: false,
    };
  },
  mounted() {
    this.getMasters();
    console.log("form", this.form);
  },
  methods: {
    async getData() {
      let encryptedId = this.$route.params.storeProductId;
      await axios
        .get(`/store_products/${encryptedId}`)
        .then((response) => {
          this.store_product = response.data.data;
          this.old_json = response.data.data;
          this.form.store_product_id = this.store_product.id;
          this.form.product_id = this.store_product.product_id;
          this.form.store_id = this.store_product.store_id;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      console.log("form", this.form);
    },
    async getMasters() {
      await axios
        .get(`product_stocks/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
          //Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.business_name,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
      this.getData();
    },
    async save() {
      try {
        this.isLoading = true;
        console.log("ttt", this.form);

        await axios.post("/product_stocks", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
